import { Component } from "react";
import { Navigate } from "react-router-dom";
import { withRouter } from '../../common/with-router';
import {Card, Form, Button, Row, Col, Table } from "react-bootstrap";
import { FaPlus, FaSearch, FaTrash, FaEraser, FaEye } from "react-icons/fa";
import api from "../../services/api";
import { hasPerm, 
         tiposChamados, 
         getCurrentUser, 
         statusChamados, 
         prioridadeChamados, 
         formataDataHoraExibicao, 
         addBusinessDays, 
         formataDataExibicao } from '../../common/utils';
import Paginacao from '../../common/pagination';
import Swal from 'sweetalert2';
import AsyncSelect from 'react-select/async';

class Chamados extends Component {
    constructor(props) {
        super(props);
        this.onClickPagina = this.onClickPagina.bind(this);
        this.buscaChamado = this.buscaChamado.bind(this);
        this.carregaProgramasDelay = this.delayCamposAsync(this.carregarProgramas.bind(this), 3000);
        this.carregaUsuariosFuncionariosDelay = this.delayCamposAsync(this.carregarUsuariosFuncionarios.bind(this), 3000);

        this.state = {
            listRegistros: [],
            error: "",
            dados_usuario: "",
            tipo: "",
            numero: "",
            prioridade: "",
            filtro_data_inicio: "",
            filtro_data_fim: "",
            status: "",
            solicitante: "",
            filtro_cadastrado_por_id: "",
            filtro_cadastrado_por_nome: "",
            filtro_programa_id: "",
            filtro_programa_nome: "",
            programasOptions: [],
            loadingProgramas: false,

            page_numb: 1,
            loading: true,
        };
    }

    componentDidMount(){
        this.consultaChamados(this.state.busca, this.state.page_numb)
    }

    consultaChamados = (page_numb = 1) => {
        const dados_usuario = getCurrentUser();

        const tipo = (dados_usuario?.tipo_usuario || '').toLowerCase();
        const isAdmin = tipo === '';
        const isOperOuGestor = tipo === 'operador' || tipo === 'gestor';

        this.setState({ loading: true, error: "" });

        let filtros = `?page=${page_numb}`;

        if (isAdmin || (!dados_usuario.is_superuser && dados_usuario.tipo_usuario === 'administrador')) {
            if (this.state.filtro_programa_id) {
                filtros += `&programa_id=${this.state.filtro_programa_id}`;
            }
        } else {
            if (dados_usuario?.ambiente_programa_id) {
                filtros += `&programa_id=${dados_usuario.ambiente_programa_id}`;
            }
        }

        if (this.state.numero) {
            filtros += `&numero=${encodeURIComponent(this.state.numero)}`;
        }

        if (this.state.tipo) {
            filtros += `&tipo=${encodeURIComponent(this.state.tipo)}`;
        }

        if (this.state.filtro_data_inicio) {
            filtros += `&data_inicio=${this.state.filtro_data_inicio} 00:00:00`;
        }
        if (this.state.filtro_data_fim) {
            filtros += `&data_fim=${this.state.filtro_data_fim} 23:59:59`;
        }

        if (this.state.status) {
            filtros += `&status=${encodeURIComponent(this.state.status)}`;
        }

        if (this.state.prioridade) {
            filtros += `&prioridade=${encodeURIComponent(this.state.prioridade)}`;
        }
        

        if (isOperOuGestor) {
            if (dados_usuario?.id) {
                filtros += `&solicitante_id=${encodeURIComponent(dados_usuario.id)}`;
            }
        } else if (isAdmin) {
            if (this.state.solicitante) {
                filtros += `&solicitante=${encodeURIComponent(this.state.solicitante)}`;
            }
            if (this.state.filtro_cadastrado_por_id) {
                filtros += `&cadastrado_por_id=${encodeURIComponent(this.state.filtro_cadastrado_por_id)}`;
            }
        }

        api.get(`/chamados/${filtros}`)
        .then((response) => {
            this.setState({
                loading: false,
                error: "",
                listRegistros: response.data,
                page_numb,
            });
        })
        .catch((error) => {
            let erro_msg = 'Erro ao consultar chamados, tente novamente.';

            if (error.response && error.response.status === 500) {
                erro_msg = 'Servidor indisponível no momento';
            } else if (error.response && error.response.status === 403) {
                erro_msg = 'Você não tem permissão para acessar essa área';
            }
        this.setState({
                loading: false,
                error: erro_msg,
        });
        });
    };

    delayCamposAsync = (fn, delay = 3000) => {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            return new Promise((resolve) => {
            timeout = setTimeout(async () => {
                try {
                const res = await fn(...args);
                resolve(res);
                } catch (e) {
                resolve([]); 
                }
            }, delay);
            });
        };
    };

    carregarUsuariosFuncionarios = async (inputValue = "") => {
        try {
            const q = inputValue ? `&nome=${encodeURIComponent(inputValue)}` : "";
            const response = await api.get(`/usuarios/?page=1&funcionario=True${q}`);
            const results = Array.isArray(response.data?.results)
                ? response.data.results
                : (Array.isArray(response.data) ? response.data : []);

            return results.map((u) => {
                const first = (u.first_name || "").trim();
                const last = (u.last_name || "").trim();
                const email = (u.email || "").trim();
                const displayName = [first, last].filter(Boolean).join(" ").trim();

                let label = "";
                if (displayName && email) label = `${displayName} (${email})`;
                else if (displayName) label = displayName;
                else label = email;

                return { value: u.id, label };
            });
        } catch (error) {
            console.error("Erro ao carregar usuários:", error);
            return [];
        }
    };

    renderRows = () => {
        const dados_usuario = getCurrentUser();

        if ('results' in this.state.listRegistros && this.state.listRegistros.results.length > 0) {
            return this.state.listRegistros.results.map((item) => {
            const abertura = item?.criado_em ? new Date(item.criado_em) : null;
            const sla = Number(item?.sla) || Number(item?.sla_prazo_dias) || 0;
            const previsao = abertura ? addBusinessDays(abertura, sla) : null;

            return (
                <tr key={item.id}>
                <td><strong>#{item.numero}</strong></td>
                <td>
                    {item.dados_programa.nome}
                    <p className="mb-0"><i>Solicitante: {item.dados_solicitante.nome}</i></p>
                    {item?.dados_cadastrado_por?.nome && (
                        <p className="mb-0"><i>Criado por: {item.dados_cadastrado_por.nome}</i></p>
                    )}
                </td>
                <td>
                    {item.tipo ? (
                        <span className="badge bg-secondary text-white" style={{ fontSize: '0.85em', fontWeight: 'normal' }}>
                            {tiposChamados[item.tipo] ?? item.tipo}
                        </span>
                    ) : (
                        <span className="text-muted">-</span>
                    )}
                </td>
                <td>
                    <span className={`badge badge-agendamento badge-status-${String(item.status).toLowerCase()}`}>
                    {statusChamados[item.status] ?? item.status}
                    </span>
                </td>
                <td>
                    <span className={`badge badge-prioridade badge-prioridade-${String(item.prioridade)}`}>
                    {prioridadeChamados[Number(item.prioridade)] ?? item.prioridade}
                    </span>
                </td>
                <td>{abertura ? formataDataHoraExibicao(abertura) : "-"}</td>
                <td>{previsao ? formataDataExibicao(previsao) : "-"}</td>
                <td className="text-end">
                    <Button variant="light" href={"/chamados/edit/" + item.id} size="sm">
                        <FaEye /> Visualizar
                    </Button>

                    {dados_usuario['tipo_usuario'] === "" && (
                        <Button
                            className={String(item?.status || "").toLowerCase() === "concluido" ? "invisible" : ""}
                            variant="danger"
                            size="sm"
                            onClick={() => this.handleDelete(item.id)}
                        >
                            <FaTrash />
                        </Button>
                    )}
                </td>
                </tr>
            );
            });
        }

        return (
            <tr>
            <td colSpan={7}>Nenhum Chamado encontrado</td>
            </tr>
        );
        };


    handleDelete = (id) => {
        Swal.fire({
            title: 'Tem certeza?',
            text: "Essa ação não poderá ser desfeita!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sim, excluir!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                api.delete(`/chamados/${id}`)
                .then(() => {
                    Swal.fire(
                        'Excluído!',
                        'Chamado foi excluída com sucesso.',
                        'success'
                    );
                    this.consultaChamados(this.state.busca, this.state.page_numb);
                })
                .catch(() => {
                    Swal.fire(
                        'Erro!',
                        'Ocorreu um problema ao excluir o chamado.',
                        'error'
                    );
                });
            }
        });
    }

    handleChangeFiltros = (event, fieldName) => {
        if (fieldName === 'programa_id') {
            this.setState({
                filtro_programa_id: event?.value || "",
                filtro_programa_nome: event?.label || "",
            });
        } else if (fieldName === 'cadastrado_por_id') {
            this.setState({
                filtro_cadastrado_por_id: event?.value || "",
                filtro_cadastrado_por_nome: event?.label || "",
            });
        } else {
            const { name, value } = event.target;
            this.setState({ [name]: value });
        }
    };

    carregarProgramas = async (inputValue = "") => {
        try {
            if (!inputValue) {
                this.setState({ loadingProgramas: true });
            }

            const response = await api.get(`/programas/?nome=${inputValue}`);
            const opcoes = response.data.results.map(programa => ({
                value: programa.id,
                label: programa.nome
            }));

            if (!inputValue) {
                this.setState({
                    programasOptions: opcoes,
                    loadingProgramas: false
                });
            }
            return opcoes;

        } catch (error) {
            console.error("Erro ao carregar programas:", error);
            if (!inputValue) {
                this.setState({ loadingProgramas: false });
            }
            return [];
        }
    };

    onClickPagina(num_page) {
        this.setState({
            loading: true,
            page_numb: num_page
        });
        
        this.consultaChamados(this.state.busca, num_page)
    }

    buscaChamado(e) {
        e.preventDefault();

        this.setState({
            loading: true,
        });
        
        this.consultaChamados(this.state.busca)
    }

    limpaFiltro = () => {
        this.setState({
            numero: "",
            tipo: "",
            prioridade: "",
            filtro_data_inicio: "",
            filtro_data_fim: "",
            status: "",
            filtro_solicitante_id: "",
            filtro_solicitante_nome: "",
            filtro_cadastrado_por_id: "",
            filtro_cadastrado_por_nome: "",
            filtro_programa_id: "",
            filtro_programa_nome: "",
        }, () => {
            this.consultaChamados(1);
        })  
    }

    render() {
        if (!hasPerm('view_chamados')) {
            return <Navigate to='/sem-permissao' />
        }
        const customStyles = {
            option: (provided) => ({
                ...provided,
                fontSize: '13px',
            }),
            singleValue: (provided) => ({
                ...provided,
                fontSize: '13px',
            }),
        };

        const dados_usuario = getCurrentUser();

        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">Chamados</h4>
                    </Col>
                    <Col sm={6} lg={6} className="text-end">
                        <Button variant="secondary" href="/chamados/add" className="mb-3" size="sm">
                            <FaPlus /> Novo Chamado
                        </Button>
                    </Col>
                </Row>
                <Card className="cardDestaque">
                    <Card.Body>    
                        <h4>Filtros</h4>
                        <Form method="get" onSubmit={this.buscaChamado}>
                            <Row>
                                <Col sm={2} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Número</Form.Label>                            
                                        <Form.Control
                                            type="text"
                                            name="numero"
                                            value={this.state.numero}
                                            onChange={this.handleChangeFiltros}
                                            placeholder="Número do Chamado"

                                        />
                                    </Form.Group>
                                </Col>
                                <Col sm={2} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Status</Form.Label>
                                        <Form.Control
                                            as="select"
                                            name="status"
                                            value={this.state.status}        
                                            onChange={this.handleChangeFiltros}
                                        >
                                            <option value="">Todos</option>
                                        {Object.entries(statusChamados).map(([value, label]) => (
                                            <option key={value} value={value}>{label}</option>
                                        ))}
                                        </Form.Control>
                                    </Form.Group>

                                </Col>

                                {dados_usuario.tipo_usuario === "" && (
                                    <Col sm={3} xs={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Tipo</Form.Label>
                                            <Form.Control
                                                as="select"
                                                name="tipo"
                                                value={this.state.tipo}
                                                onChange={this.handleChangeFiltros}
                                            >
                                                <option value="">Todos</option>
                                                {Object.entries(tiposChamados).map(([value, label]) => (
                                                    <option key={value} value={value}>{label}</option>
                                                ))}
                                            </Form.Control>
                                        </Form.Group>
                                    </Col>
                                )}

                                {dados_usuario['tipo_usuario'] === "" && (
                                    <Col sm={2} xs={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Prioridade</Form.Label>
                                            <Form.Control
                                                as="select"
                                                name="prioridade"
                                                value={this.state.prioridade}
                                                onChange={this.handleChangeFiltros}
                                            >
                                                <option value="">Todas</option>
                                            {Object.entries(prioridadeChamados).map(([value, label]) => (
                                                <option key={value} value={String(value)}>{label}</option>
                                            ))}
                                            </Form.Control>
                                        </Form.Group>
                                    </Col>
                                )}

                                {dados_usuario['tipo_usuario'] === "" && (
                                    <Col sm={3} xs={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Solicitante</Form.Label>
                                            <AsyncSelect
                                                cacheOptions
                                                loadOptions={this.carregaUsuariosFuncionariosDelay}
                                                defaultOptions
                                                name="cadastrado_por_id"
                                                placeholder="Selecione o usuário"
                                                noOptionsMessage={() => "Nenhum usuário encontrado"}
                                                onChange={e => this.handleChangeFiltros(e, 'cadastrado_por_id')}
                                                value={this.state.filtro_cadastrado_por_id ? { value: this.state.filtro_cadastrado_por_id, label: this.state.filtro_cadastrado_por_nome } : null}
                                                styles={customStyles}
                                            />
                                        </Form.Group>
                                    </Col>
                                )}

                                {/*dados_usuario.tipo_usuario === '' && (
                                <Col sm={3} xs={12}>
                                    <FormGroup className="mb-3">
                                        <Form.Label>Solicitante</Form.Label>
                                        <Form.Control
                                            name="solicitante"
                                            type="text"
                                            value={this.state.solicitante}
                                            onChange={this.handleChangeFiltros}
                                        />
                                    </FormGroup>
                                </Col>
                                )*/}

                                {!dados_usuario.ambiente_programa_id && (
                                <Col sm={3} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Programa</Form.Label>
                                        <AsyncSelect
                                            key={this.state.programa_id}                     
                                            cacheOptions
                                            loadOptions={this.carregaProgramasDelay} 
                                            defaultOptions                       
                                            onMenuOpen={() => this.carregarProgramas("")} 
                                            name="programa_id"
                                            placeholder="Nome do Programa"
                                            noOptionsMessage={() => "Nenhum programa encontrado"}
                                            onChange={e => this.handleChangeFiltros(e, 'programa_id')}
                                            value={this.state.filtro_programa_id ? { value: this.state.filtro_programa_id, label: this.state.filtro_programa_nome } : null}
                                            styles={customStyles}
                                        />
                                    </Form.Group>
                                </Col>
                                )}

                                {/*}
                                <Col sm={3} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Data Início</Form.Label>
                                        <Form.Control
                                            type="date"
                                            name="filtro_data_inicio"
                                            value={this.state.filtro_data_inicio}
                                            onChange={e => this.handleChangeFiltros(e, 'filtro_data_inicio')}

                                        />
                                    </Form.Group>
                                </Col>
                                {this.state.filtro_data_inicio && (
                                    <Col sm={3} xs={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Data Fim</Form.Label>
                                            <Form.Control
                                                type="date"
                                                name="filtro_data_fim"
                                                value={this.state.filtro_data_fim}
                                                onChange={e => this.handleChangeFiltros(e, 'filtro_data_fim')}
                                            />
                                        </Form.Group>
                                    </Col>
                                )*/} 
                            </Row>

                            <Button type="submit" variant="success" size="sm">
                                <FaSearch className="me-2" /> Filtrar
                            </Button>
                            <Button type="button" size="sm" variant="light" className="ms-2" onClick={() => this.limpaFiltro()}>
                                <FaEraser /> Limpar filtro
                            </Button>
                        </Form>
                    </Card.Body>
                </Card>
                <Card className="cardDestaque">
                    <Card.Body className="pt-0">    
                        <Table responsive className="custom-table">
                            <thead>
                                <tr>
                                    <th>Número</th>
                                    <th>Programa / Solicitante</th>
                                    <th>Tipo</th>
                                    <th>Status</th>
                                    <th>Prioridade</th>
                                    <th>Criado Em:</th>
                                    <th>Previsão:</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.loading ? (
                                <tr>
                                    <td colSpan={7}>Carregando...</td>
                                </tr>
                                ) : (
                                    this.state.error ? (
                                        <tr>
                                            <td colSpan={7}>{this.state.error}</td>
                                        </tr>
                                    ) : this.renderRows()
                                )}                                                       
                            </tbody>
                        </Table>       
                        { 
                            'results' in this.state.listRegistros && this.state.listRegistros.results.length > 0 && 
                            <Paginacao dados={this.state.listRegistros} loading={this.state.loading} page_numb={this.state.page_numb} _onClickPagina={this.onClickPagina} />
                        }                    
                    </Card.Body>                
                </Card>
            </div>
        );
    }
}

export default withRouter(Chamados);
